import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { MINUTES_TO_MILLIS } from "lopermut"
import {
  CanonicalTopicsGroupedDataSchema,
  DataResponse,
  GetBackofficeCanonicalTopicGroupedSchema,
} from "schema"
import z from "zod"

type Query = z.infer<typeof GetBackofficeCanonicalTopicGroupedSchema>
type Response = DataResponse<z.infer<typeof CanonicalTopicsGroupedDataSchema>>

type Props = {
  companyId: string
  query: Query
  enabled?: boolean
}

const getBackofficeCanonicalTopicsGroupedQueryKey = (companyId: string, query: Query) => [
  "canonical-topic",
  companyId,
  query,
]

export const getBackofficeCanonicalTopicsGroupedQuery = ({
  companyId,
  query,
  enabled = true,
}: Props) => {
  return queryOptions({
    queryKey: getBackofficeCanonicalTopicsGroupedQueryKey(companyId, query),
    staleTime: 10 * MINUTES_TO_MILLIS,
    queryFn: async () => {
      const { data } = await axios.get<Response>(`/backoffice/canonicalTopics/grouped`, {
        params: { ...query, companyId },
      })

      return data.data.groups
    },
    enabled,
  })
}
